/*
 * Copyright (c) 2020 JCA Electronics , Winnipeg, MB. All rights reserved.
 */

import { Point } from './Point';
import { Guid } from 'guid-typescript';
import { deserialize, deserializeArray, serialize, Type } from 'class-transformer';

export class FieldOperationsModel {
  ErrorNotes: string;

  FieldName: string;

  BoundaryWidth: number;

  FieldID: string;

  CustomerID: string;

  BoundaryPoints: Point[];

  InnerHeadlandPoints: Point[];

  InteriorGroupPoints: Point[][];

  PartFieldPoints: Point[][];

  StagingAreaPoints: Point[][];

  StagingAreaStartPoints: Point[];

  @Type(() => Date)
  LastModifiedUTC: Date;

  constructor() {
    this.ErrorNotes = '';
    this.FieldName = 'None';
    this.BoundaryWidth = 0;
    this.FieldID = Guid.EMPTY.toString();
    this.CustomerID = Guid.EMPTY.toString();
    this.BoundaryPoints = [];
    this.InnerHeadlandPoints = [];
    this.InteriorGroupPoints = [[], []];
    this.PartFieldPoints = [[], []];
    this.StagingAreaPoints = [[], []];
    this.StagingAreaStartPoints = [];
    this.LastModifiedUTC = new Date();
  }

  static toModel(json: string): FieldOperationsModel {
    const model = deserialize(FieldOperationsModel, json);
    return model;
  }

  static toModelCollection(json: string): FieldOperationsModel[] {
    const models = deserializeArray(FieldOperationsModel, json);
    return models;
  }

  public fromModelToJson(): string {
    const jsObj = serialize(this);
    return jsObj;
  }
}
